import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import AnalyticChartData from "../../../../../api/AnalyticChartData";
import stateAnalyticApp from "../../../../../state/stateAnalyticApp";
import { GraphComponent } from "../GraphComponent";
import { FilterLegend } from "../FilterLegend";
import { RechartsLineBarChart } from "./RechartsLineBarChart";

export const PrintDatesChart = observer(
  ({ refApp, shiftPress, setScaleGraph, setScaleGraphFlag }) => {
    const [modeLegend, setModeLegend] = useState("index");
    const chartSource = AnalyticChartData.DataSet.PRINT.dates;
    const isLoaded = stateAnalyticApp.loaded_printed_dates;
    const hasData = chartSource.series.length > 0;

    if (isLoaded && !hasData) {
      return null;
    }

    return (
      <GraphComponent
        setScaleGraph={setScaleGraph}
        setScaleGraphFlag={setScaleGraphFlag}
        refApp={refApp}
        shiftPress={shiftPress}
        title="Печать этикеток. По датам"
        flag_loaded={isLoaded}
        id="dates"
      >
        {/* <FilterLegend
          value={modeLegend}
          onChange={(e) => setModeLegend(e.target.value)}
        /> */}
        <RechartsLineBarChart
          chartData={chartSource.chartData}
          series={chartSource.series}
          type="line"
          tooltipShared={modeLegend === "index"}
        />
      </GraphComponent>
    );
  },
);
